import React from 'react';
import {Row, Col, Card} from 'react-materialize';
import biological from "../../images/biological.png";
import zoonoses from "../../images/zoonoses.png";
import {FormattedMessage} from "react-intl";

const RiscoBiologico = () => (

    <Card>
        {/*RISCOS BIOLÓGICOS*/}

        <Row>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={biological} className={"img"}/> </div>

            </Col>

            <Col s={10} m={10}>
                <h5><p><b><FormattedMessage id={"biological"} defaultMessage={"Risco biológico"}/></b></p></h5>
            </Col>

        </Row>

        <Row className={"valign-wrapper"}>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={zoonoses} className={"img"}/>
                </div>
            </Col>

            <Col s={10} m={10}>
                <div align="justify">
                    <p><b><FormattedMessage id={"zoo"} defaultMessage={"Zoonoses"}/></b></p>
                    <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo"}/></b></li>
                        <p><FormattedMessage id={"zoo.text"} defaultMessage={"Manuseio ou atividades que promovem o contato direto com patógenos;"}/></p>
                        <p><FormattedMessage id={"zoo.text2"} defaultMessage={"Contato acidental;"}/></p>
                        <p><FormattedMessage id={"zoo.text3"} defaultMessage={"Contato através da água;"}/></p>
                        <p><FormattedMessage id={"zoo.text4"} defaultMessage={"Contato através de contato com animais."}/></p>
                        <li><b> <FormattedMessage id={"risks"} defaultMessage={"Risco/Danos à Saúde:"}/></b></li>
                        <p><FormattedMessage id={"zoo.text5"} defaultMessage={"Infecções;"}/></p>
                        <p><FormattedMessage id={"zoo.text6"} defaultMessage={"Infestação de patógenos no local de trabalho."}/></p>
                        <li><b><FormattedMessage id={"control"} defaultMessage={"Controle e prevenção:"}/></b></li>
                        <ul className={"browser-default"}>
                            <li><b><FormattedMessage id={"elimination"} defaultMessage={"Eliminação ou substituição:"} /></b></li>
                        <p><FormattedMessage id={"zoo.text7"} defaultMessage={"Controle e eliminação de pragas e vetores."}/></p>
                            <li><b><FormattedMessage id={"engineering"} defaultMessage={"Controles de engenharia:"}/></b></li>
                        <p><FormattedMessage id={"zoo.text8"} defaultMessage={"Controle da vegetação em torno de tanques e instalações;"}/></p>
                        <p><FormattedMessage id={"zoo.text9"} defaultMessage={"Vacinação."}/></p>
                            <li><b><FormattedMessage id={"administration"} defaultMessage={"Administrativos e EPIs:"}/></b></li>
                        <p><FormattedMessage id={"zoo.text10"} defaultMessage={"Higienização;"}/></p>
                            <p><FormattedMessage id={"zoo.text11"} defaultMessage={"Equipamento de proteção individual apropriados."}/></p> </ul></ul>

                </div> <br/>
            </Col>
        </Row>

    </Card>
);

export default RiscoBiologico;